// @ts-nocheck

import React from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'antd'
import { Icon } from '@lmc/ui-kit'

const ExpandIcon = (props) => {
  const { open } = props

  return open ? <Icon name="DownOutlined" /> : <Icon name="UpOutlined" />
}

/**
@description Renders an Antd Collapse component.
Only displays a single panel, but anything can
be passed in via children.

https://ant.design/components/collapse/

@param {node} children. All the stuff that's displayed
when you click on the arrow.

@param {string} className. Allows customisation of
stylings. You'll need to add the class in a less file.

@param {bool} defaultOpen. Toggles whether or not
the Collapse is open by default.

@param {node} header. The stuff displayed next to
the arrow. Always displayed.

@param {string} iconPosition. Can be either right
or left. Toggles where the arrow is displayed
relative to the header.

@returns {function} AntdCollapseSingle.
*/

export default function AntdCollapseSingle(props) {
  const {
    children,
    className,
    defaultOpen = true,
    header,
    iconPosition = 'right',
  } = props

  const [open, setOpen] = React.useState(defaultOpen)

  const { Panel } = Collapse

  return (
    <Collapse
      className={className}
      expandIcon={() => (
        <span>
          <ExpandIcon open={open} />
        </span>
      )}
      expandIconPosition={iconPosition}
      ghost
      onChange={() => setOpen(!open)}
      style={styles.container}
    >
      <Panel header={header} style={styles.container}>
        {children}
      </Panel>
    </Collapse>
  )
}

AntdCollapseSingle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  defaultOpen: PropTypes.bool,
  header: PropTypes.node,
  iconPosition: PropTypes.string,
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
}
